import type {
  SimpleBoolean,
  SimpleBooleanFilter,
} from "shared/resources/Stream";
import type { Nullable } from "shared/types";

export default function useSimpleBooleanParams() {
  function simpleBooleanParams(filter: Nullable<SimpleBoolean>) {
    if (!filter) return null;

    return Object.fromEntries(
      Object.entries(filter).map(([key, values]) => [
        key,
        values.map((value: SimpleBooleanFilter) => {
          const { suggestionIndex, isSuggestion, ...rest } = value;

          return rest;
        }),
      ])
    );
  }

  return {
    simpleBooleanParams,
  };
}
